import http from "../api/axios-auth-php-frontend";

class RecognitionService {

    // ── Feed ──────────────────────────────────────────────
    getFeed(params = {}) {
        return http.get("recognition/feed", { params });
    }

    // ── Users (autocomplete search) ───────────────────────
    getUsers(search = "") {
        return http.get("recognition/users", {
            params: search ? { search } : {},
        });
    }

    // ── Quota (available giving balance) ─────────────────
    getMyQuota() {
        return http.get("recognition/quota");
    }

    // ── Give Recognition ──────────────────────────────────
    // payload: { recipient_ids, points, message, category }
    giveRecognition(payload) {
        return http.post("recognition/give", payload);
    }

    // ── History ───────────────────────────────────────────
    // params: { type: 'received'|'given', period?, page?, limit? }
    getHistory(params = {}) {
        return http.get("recognition/history", { params });
    }
}

export default new RecognitionService();